import { Popover } from 'antd';
import { ReportItem, CEControl } from 'store/ducks/Reporting/types';
import { InfoPopover } from '../InfoPopover';
import { InfoCircleOutlined } from '@ant-design/icons';
import { StyledInfoButton } from '../BusinessProcessTree.styled';

const flattenControl = (control: CEControl) => ({
  control_description: control.control_description,
  owner_name: control.owner?.name,
  key_control: control.key_control,
  control_type_name: control.control_type?.name,
  control_1_overall_effectiveness_name:
    control.control_1?.control_overall_effectiveness?.name,
  control_1_status_name: control.control_1?.control_status?.name,
  control_1_owner_name: control.control_1?.owner?.name,
  control_2_design_effectiveness_name:
    control.control_2?.design_effectiveness?.name,
  control_2_last_test_date_design: control.control_2?.last_test_date_design,
  control_2_performer_tod: control.control_2?.performer_tod,
  control_2_approver: control.control_2?.approver,
  control_3_operating_effectiveness_name:
    control.control_3?.operating_effectiveness?.name,
  control_3_last_test_date_operational:
    control.control_3?.last_test_date_operational,
  control_3_next_test_date: control.control_3?.next_test_date,
  control_3_test_result_name: control.control_3?.test_result?.name,
  control_4_attestation_effectiveness_name:
    control.control_4?.control_attestation_effectiveness?.name,
  control_4_control_effectiveness_name:
    control.control_4?.control_effectiveness?.name,
  control_4_test_status_name: control.control_4?.test_status?.name
});

export const InfoButton = ({
  type,
  item
}: {
  type:
    | 'process'
    | 'risk'
    | 'control'
    | 'gap'
    | 'audit'
    | 'solution'
    | 'controlEffectiveness';
  item: ReportItem | CEControl;
}) => {
  const flatItem =
    type === 'controlEffectiveness' ? flattenControl(item as CEControl) : item;

  return (
    <Popover
      placement='right'
      content={<InfoPopover type={type as any} item={flatItem as any} />}
    >
      <StyledInfoButton
        size='small'
        shape='circle'
        icon={<InfoCircleOutlined />}
      />
    </Popover>
  );
};
